import { TipoMapaTalhoes } from "core/features/maps/typings";
import URL from "core/resources/urls";
import http from "infra/http";
import { useQuery } from "react-query";

export interface SafraPeriodoProps {
  id: string;
  codigo: number;
  nome: string;
  nomeOriginal: string;
}

const useSafraPeriodo = (ocupacaoId: string, safraId: string, tipoMapa: TipoMapaTalhoes) => {
  return useQuery(
    [
      URL.IMPORTAR_TALHOES.SAFRA_PERIODO_OCUPACAO(safraId, ocupacaoId),
      ocupacaoId,
      safraId,
      tipoMapa,
    ],
    async () => {
      const { data } = await http.get(
        URL.IMPORTAR_TALHOES.SAFRA_PERIODO_OCUPACAO(safraId, ocupacaoId)
      );

      return {
        items: data as SafraPeriodoProps[],
      };
    },
    {
      enabled: !!ocupacaoId && !!safraId,
    },
  );
};

export default useSafraPeriodo;
